import type { schemaType } from '~~/modules/api/strapi/vacaciones-landings/detail/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-short-description/s-short-description.vue'

export const useToSShortDescription = () => {
  const fromStrapiHolidaysDetail = (
    data: schemaType,
  ): propsInterface['text'] => {
    const shortDescription = data.attributes.short_description
    return shortDescription
  }

  return { fromStrapiHolidaysDetail }
}
